<div *ngFor="let errorData of errorDialogData, let count = index">
    <h1 mat-dialog-title class="multiple-dialog-title" [ngSwitch]="errorData.type">
        <i *ngSwitchCase="'error'" class="header-icon material-icons">error</i>
        <i *ngSwitchCase="'warn'" class="header-icon material-icons">warning</i>
        <i *ngSwitchCase="'accent'" class="header-icon material-icons">check_circle</i>
        <i *ngSwitchDefault class="header-icon material-icons">info</i>
        {{((errorData.title || '') | mxTranslate)()}}
    </h1>
    <div mat-dialog-content>
        <p [innerHTML]="((errorData.message || '?') | mxTranslate)()"></p>
    </div>
    <hr *ngIf="count != errorDialogData.length - 1"/>
</div>
<div mat-dialog-actions>
    <mx-button [buttonModel]="okButton"></mx-button>
</div>
